export default "__VITE_PUBLIC_ASSET__c1cc37e0__"